<template>
    <div class="flex flex-col items-center">
        <transition mode="out-in">
            <div
                v-if="!interruptionShow"
                class="flex flex-col items-center gap-y-10 large:gap-y-7"
            >
                <QuestionInputs
                    type="multiple"
                    :title="$root.data.questionTextDiet"
                    :text="$root.data.questionInfoDiet"
                    :values="$root.config.quiz.diet"
                    :flex-config="{desktop: {maxWidth: '32.625rem'}}"
                    @value-changed="(value) => handleUpdate(value)"
                />
                <div class="w-full flex justify-center">
                    <button
                        class="button button--primary-on-light"
                        @click="handleNext"
                        :disabled="!value?.length"
                    >
                        {{ $root.config.translations.misc.nextStep }}
                    </button>
                </div>
            </div>
            <Interruption
                v-else-if="interruptionContent && interruptionShow"
                :config="{content: interruptionContent}"
                @goToNext="goToNext(value)"
            />
        </transition>
    </div>
</template>

<script>
    import QuestionInputs from '@/apps/quiz/components/QuestionInputs.vue';
    import Interruption from '@/apps/quiz/components/Interruption.vue';

    export default {
        components: {
            QuestionInputs,
            Interruption
        },
        data () {
            return {
                interruptionShow: false,
                interruptionInstance: null,
                interruptionContent: null,
                value: null
            }
        },
        methods: {
            handleUpdate (value) {
                this.value = value;
            },
            handleNext () {
                this.interruptionInstance = this.$root.config.quiz.diet.find(answer => answer.id === this.value[0]).interruption;

                if (this.interruptionInstance !== 'undefined' || this.interruptionInstance !== null) {
                    this.interruptionContent = this.interruptionInstance;
                }

                setTimeout(() => {
                    if (this.interruptionContent) {
                        this.interruptionShow = true;
                        window.innerWidth < 1024 ? window.scrollTo(0, 0) : document.querySelector('.js-route-content-container').scrollTo(0, 0);
                    } else {
                        this.goToNext(this.value);                        
                    }
                }, 300);
            },
            goToNext (value) {
                this.$router.push({
                    name: 'Beauty',
                    params: {
                        diet: value.join(',')
                    }
                });
            }
        }
    };
</script>
